module.exports = __webpack_public_path__ + "img/pic11.2403b01e.png";